module.exports = __webpack_public_path__ + "assets/img/collection_1.a7d02cf3.svg";